import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { searchAddress } from '../../store/address/address.actions'
import { selectIsFrenchSite } from '../../store/navigation/navigation.selectors'
import { selectSearchTerms } from '../../store/search/search.selectors'
import { suggestServiceCtx } from '../../store/suggest/suggest.service.constants'
import BackButton from '../header/BackButton'
import SearchInput from '../header/SearchInput'
import { useT } from '../i18n/T'
import { useAction } from '../utils/react-redux'
import s from './AddressHeaderForm.less'

export const AddressHeaderForm = ({ hasBackTag, transparent }) => {
  const isFrench = useSelector(selectIsFrenchSite)
  const searchTerms = useSelector(selectSearchTerms)
  const [value, setValue] = useState(searchTerms)
  const [loading, setLoading] = useState(false)
  const execSearchAddress = useAction(searchAddress)
  const SearchInputRef = useRef()
  const placeholder = useT('header.search.placeholder')

  useEffect(() => {
    // if searchTerms has been reset, we empty search field
    setValue(searchTerms)
  }, [searchTerms])

  const onChange = ({ value: val }) => {
    setValue(val)
  }

  const onSubmit = e => {
    e.preventDefault()
    if (!value) return

    setLoading(true)

    return SearchInputRef.current
      .onSubmit()
      .then(() => execSearchAddress({ terms: value }))
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <nav>
        <BackButton hasTag={hasBackTag} transparent={transparent} />
      </nav>
      <form onSubmit={onSubmit} className={s.AddressHeaderForm}>
        <SearchInput
          ref={SearchInputRef}
          value={value}
          loading={loading}
          suggestFilterType={isFrench ? suggestServiceCtx.filter.all : suggestServiceCtx.filter.places}
          hasGreenPlaceholder={true}
          placeholder={placeholder}
          onChange={onChange}
          transparent={transparent}
        />
      </form>
    </>
  )
}

export default AddressHeaderForm
